import * as moment from 'moment'
import UserTopPanel from '../../components/trips/rider-info/UserTopPanel'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actions from '../../state/actions/trips/'
import * as riderActions from '../../state/actions/riders/'
import { IStoreState } from '../../types'

const mapStateToProps = (state: IStoreState, ownProps: { riderId: string; match?: any }): any => {
  const rider = state.riders.items[ownProps.riderId]
  const appliedPromotions = rider && rider.appliedPromotions ? Object.values(rider.appliedPromotions) : []
  let hasValidPromotions = false
  appliedPromotions.forEach(promo => {
    const expired = promo.expiresAt ? moment(promo.expiresAt).isBefore(new Date()) : false
    const usedUp = promo.redemptionCount >= promo.maxRedemptions
    if (!expired && !usedUp) {
      hasValidPromotions = true
    }
  })
  //Get Current Trip by ID
  const currentTripId = ownProps.match.params.tripId
  const currentTrip = state.trips.items[currentTripId]
  return {
    ...ownProps,
    hasValidPromotions,
    rider,
    currentTrip
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderPersonalInfo: (riderId: string) => {
      return dispatch(riderActions.getRiderPersonalInfo(riderId))
    },
    getAppliedPromotions: (riderId: string) => {
      return dispatch(riderActions.getAppliedPromotions(riderId))
    }
  }
}

export default withRouter(
  connect<RouteComponentProps<any>, any, any>(
    mapStateToProps,
    mapDispatchToProps
  )(UserTopPanel)
)



// WEBPACK FOOTER //
// ./src/containers/trips/UserTopPanel.ts